import {NgModule} from '@angular/core';
// Children
import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboardComponent} from './dashboard.component';
import {SharedModule} from '../shared/shared.module';
// Event trigger
import {TriggerService} from './event/shared/service/trigger.service';
// Timeline
import {TimelineModule} from './timeline/timeline.module';
// Onboard
import {WelcomeComponent} from './onboard/welcome.component';
import {InviteGuideComponent} from './onboard/invite-guide.component';
import {GridFloorToggleComponent} from './components/grid-floor-toggle/grid-floor-toggle.component';
import {IconModule} from '../vision/icon';
import {FloorPlanModule} from '../floor-plan/floor-plan.module';
import {reducers} from './reducers';
import {StoreModule} from '@ngrx/store';
import {BackdropModule} from '../vision/backdrop/backdrop.module';
// Graph
import {GraphModule} from '../graph/graph.module';
// Shared
import {ClipboardService, DashboardService, EventService, NotificationService} from './shared';
import {DeviceGridModule} from '../device-grid/device-grid.module';


@NgModule({
  imports: [
    StoreModule.forFeature('dashboard', reducers),
    SharedModule,
    DashboardRoutingModule,
    FloorPlanModule,
    TimelineModule,
    IconModule,
    BackdropModule,
    DeviceGridModule,
    GraphModule
  ],
  declarations: [
    DashboardComponent,
    WelcomeComponent,
    InviteGuideComponent,
    GridFloorToggleComponent
  ],
  providers: [
    NotificationService,
    TriggerService,
    DashboardService,
    EventService,
    ClipboardService
  ],
  entryComponents: [
    WelcomeComponent,
    InviteGuideComponent
  ]
})
export class DashboardModule {
}
